import React from 'react';
import PropTypes from 'prop-types';

{
  /* <rect
  x="1"
  y="1"
  width="50"
  height="50"
  rx="4"
  fill="white"
  stroke={settings.icon === 'question' ? '#06038D' : '#C5C5C5'}
  strokeWidth="2"
/> */
}
export default function IconQuestion({size = '55px', color = '#303030'}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.81818 14.0364C3.6 13.8182 3.45455 13.4909 3.45455 13.2C3.45455 12.9091 3.56364 12.5818 3.81818 12.3636C4.07273 12.1455 4.36364 12 4.65454 12C4.94545 12 5.27273 12.1091 5.49091 12.3636C5.70909 12.6182 5.85454 12.9091 5.85454 13.2C5.85454 13.4909 5.74545 13.8182 5.49091 14.0364C5.23636 14.2545 4.94545 14.4 4.65454 14.4C4.36364 14.4 4.03636 14.2909 3.81818 14.0364ZM8.58182 6.61818C8.14546 7.09091 7.56364 7.41818 7.2 7.63636L7.09091 7.70909C6.65455 7.96364 6.36364 8.14545 6.21818 8.4C6.07273 8.58182 5.89091 8.90909 5.89091 9.6C5.89091 9.92727 5.78182 10.2182 5.52727 10.4364C5.27273 10.6545 4.98182 10.8 4.69091 10.8C4.4 10.8 4.07273 10.6909 3.85454 10.4364C3.63636 10.1818 3.49091 9.89091 3.49091 9.6C3.49091 8.47273 3.78182 7.6 4.29091 6.94545C4.8 6.29091 5.41818 5.92727 5.89091 5.67273L5.96364 5.63636C6.43636 5.34545 6.69091 5.23636 6.87273 5.01818C6.98182 4.90909 7.12727 4.69091 7.12727 4.21818C7.12727 3.96364 7.09091 3.70909 6.98182 3.49091C6.87273 3.27273 6.69091 3.05455 6.50909 2.90909C6.07273 2.58182 5.45455 2.4 4.76364 2.4C4.07273 2.4 3.41818 2.58182 3.01818 2.90909C2.8 3.05455 2.65455 3.23636 2.54545 3.49091C2.43636 3.74545 2.36364 3.96364 2.4 4.21818C2.4 4.54545 2.25455 4.83636 2.03636 5.05455C1.81818 5.27273 1.49091 5.41818 1.2 5.41818C0.90909 5.41818 0.581818 5.27273 0.363636 5.05455C0.145454 4.83636 0 4.54545 0 4.21818C0 2.8 0.654546 1.70909 1.6 0.981818C2.50909 0.290909 3.67273 0 4.8 0C5.92727 0 7.05455 0.290909 8 0.981818C8.94546 1.70909 9.6 2.8 9.6 4.21818C9.45455 5.23636 9.12727 6.03636 8.58182 6.61818Z"
        fill={color}
      />
    </svg>
  );
}

IconQuestion.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};
